import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #141b4d};
  border-bottom: 1px solid #e0e0e0};
`;

export const LoginContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const WelcomeText = styled.p`
  color: white;
  margin: 0;
  font-size: 1rem;
`;

export const Logo = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
`;

export const MainContent = styled.main`
  flex: 1;
`;
